import { Flex, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { pxToRem } from 'styles/pxToRem';

const B2B_FORM_LABEL_FONT = "'Noto Sans Arabic', 'Noto Sans', sans-serif" as const;

type B2bOptionalFieldLabelProps = {
  children: ReactNode;
};

/**
 * Field title (20px semibold) + optional suffix (12px semibold), Noto Sans Arabic / 46.31 line height.
 */
export const B2bOptionalFieldLabel = ({ children }: B2bOptionalFieldLabelProps) => (
  <Flex
    as='span'
    display='inline-flex'
    align='center'
    justify='flex-start'
    flexWrap='wrap'
    columnGap={1.5}
    rowGap={0}
    w='full'
    verticalAlign='middle'
  >
    <Text
      as='span'
      fontFamily={B2B_FORM_LABEL_FONT}
      fontWeight='600'
      fontStyle='normal'
      fontSize={{ base: pxToRem(16), lg: pxToRem(20) }}
      lineHeight={{ base: pxToRem(28), lg: pxToRem(46.31) }}
      letterSpacing='0'
      textAlign='right'
      verticalAlign='middle'
      color='dark.D800'
      sx={{ leadingTrim: 'none' }}
    >
      {children}
    </Text>
    <Text
      as='span'
      fontFamily={B2B_FORM_LABEL_FONT}
      fontWeight='600'
      fontStyle='normal'
      fontSize={pxToRem(12)}
      lineHeight={pxToRem(46.31)}
      letterSpacing='0'
      textAlign='right'
      verticalAlign='middle'
      color='dark.D500'
      sx={{ leadingTrim: 'none' }}
    >
      <FormattedMessage id='b2b.registration.field.optionalTag' defaultMessage='(Optional)' />
    </Text>
  </Flex>
);
